module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "imaget"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg7_1.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('p', {
    staticClass: "h1",
    attrs: {
      "id": "toc1"
    }
  }, [_vm._v("rotary cutting")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_vm._v("I recommend that you cut all the fabrics used in the pieced blocks, borders, and bindings with a rotary cutter, an acrylic ruler, and a cutting mat. Trim the blocks and borders with these tools as well.")]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "toc2"
    }
  }, [_vm._v("piecing")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_vm._v("All piecing measurements include ¼˝ seam allowances. If you sew an accurate ¼˝ seam, you will succeed! My biggest and best quiltmaking tip is to learn to sew an accurate ¼˝ seam.")]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "toc3"
    }
  }, [_vm._v("pressing")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_vm._v("For cotton fabrics, press seams to one side, preferably toward the darker fabric. Press flat, and avoid sliding the iron over the pieces, which can distort and stretch them. When you join two seamed sections, press the seams in opposite directions so you can nest the seams and reduce bulk.")]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "toc4"
    }
  }, [_vm._v("appliqué")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_vm._v("All appliqué instructions are for paper-backed fusible web with machine appliqué, and all the patterns have been drawn in reverse. If you prefer a different appliqué method, you will need to trace a mirror image of the pattern and add seam allowances to the appliqué pieces. A lightweight paper-backed fusible web works best for machine appliqué. Choose your favorite fusible web and follow the manufacturer’s directions.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt-f"
  }, [_c('b', [_vm._v("General Appliqué Instructions")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt-f"
  }, [_c('b', [_vm._v("1.")]), _vm._v(" Trace all parts of the appliqué design on the paper side of the fusible web. Trace each layer of the design separately. Whenever two shapes in the design butt together, overlap them by about ⅛˝ to help prevent any potential gap between them. "), _c('i', [_vm._v("Note: The pumpkins in")]), _vm._v(" Autumn Splendor "), _c('i', [_vm._v("and")]), _vm._v(" Pumpkin Patch "), _c('i', [_vm._v("were done as layered shapes instead of individual pieces")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt-f"
  }, [_c('b', [_vm._v("2.")]), _vm._v(" When tracing the shapes, extend the underlapped edge ⅛˝ beyond the drawn edge in the pattern. Write the pattern piece number on each traced shape. "), _c('i', [_vm._v("Note: Some of the patterns are larger than the width of the fusible web and will need to be traced in sections rather than as a single piece")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt-f"
  }, [_c('b', [_vm._v("3.")]), _vm._v(" Cut around the appliqué shapes, leaving a ¼˝ margin around each piece.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt-f"
  }, [_c('b', [_vm._v("4.")]), _vm._v(" Iron each fusible web shape to the wrong side of the appropriate fabric, following the manufacturer’s instructions for fusing. I don’t worry about the grainline when placing the pieces. Cut on the traced lines and peel off the paper backing. A thin layer of fusible web will remain on the wrong side of the fabric. This layer will adhere the appliqué pieces to the backgrounds.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt-f"
  }, [_c('b', [_vm._v("5.")]), _vm._v(" Position the pieces on the backgrounds. Press to fuse them in place.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt-f"
  }, [_c('b', [_vm._v("6.")]), _vm._v(" Machine stitch around the appliqué pieces, using a zigzag, satin, or blanket stitch. Stitch any detail lines indicated on the patterns. My choice is the satin stitch. I generally use matching threads for all the stitching. As always, the type of stitching you use and the thread color you select are personal choices.")])]), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "toc5"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("putting it all together")])]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('p', {
    staticClass: "noindentt-f"
  }, [_vm._v("When all the pieces for a project are completed, arrange them on the floor or, if you are lucky enough to have one, a design wall. Arrange and rearrange the pieces until you are happy with the overall look. Each project has specific directions as well as diagrams and photos for assembly.")]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "toc6"
    }
  }, [_vm._v("layering the quilt")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt-f"
  }, [_vm._v("Cut the batting and backing pieces 4˝–5˝ larger than the quilt top. Place the pressed backing on the bottom, right side down. Place the batting over the backing and then position the quilt top on top, right side up. Make sure that all the layers are flat and smooth and that the quilt top is centered over the batting and backing. Pin or baste the quilt.")]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }, [_c('div', {
    staticClass: "box2"
  }, [_c('p', {
    staticClass: "boxh"
  }, [_c('b', [_c('i', [_vm._v("note")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent-b"
  }, [_vm._v("If you are going to have your top quilted by a longarm quilter, contact the quilter for specific batting and backing requirements, as they may differ from the instructions above.")])])]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "toc7"
    }
  }, [_vm._v("quilting")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt-f"
  }, [_vm._v("Quilting is a personal choice—you may prefer hand or machine quilting. My favorite method is to send the quilt top to a longarm quilter. This method keeps the number of my unfinished tops low and the number of my finished quilts high.")]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "toc8"
    }
  }, [_vm._v("yardage and fabric requirements")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt-f"
  }, [_vm._v("I have given yardage and fabric requirements for each project. Many projects call for a total amount of assorted fabrics that can be used as a base for your project. The yardage amounts may vary, depending on the number of fabrics used and the number of pieces you cut from each fabric. Always cut the pieces for the patchwork first and then cut any appliqué pieces.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt-f"
  }, [_vm._v("Fabric amounts are based on a usable width of 42˝. Fusible web amounts are based on a width of 17˝. The amounts given for binding allow for 2˝-wide strips cut on the straight grain. I usually use the same fabric for backing and binding; it’s a good way to use leftover fabric. Cut the binding strips on either the crosswise or lengthwise grain of the leftover fabric, whichever will yield the longest strips.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt-f"
  }, [_vm._v("I used bias binding for the oval place mats. Begin by cutting one edge of the fabric at a 45° angle; then cut the binding strips from this angled edge.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07319025","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/05_General.vue
// module id = 69
// module chunks = 0